import Cookies from 'js-cookie'
import storage from './storage'

const Storage = Cookies

const TokenKey = 'jyxt_web_token_20190709010101'

const LangKey  = 'jyxt_web_lang_20190709010101'


export function getLang() {
  return Storage.get(LangKey) || window.GLOBAL.DEFAULT_LANG
}

export function setLang(e) {
  return Storage.set(LangKey, e)
}

export function getToken() {
  return Storage.get(TokenKey)
}

export function setToken(token) {
  return Storage.set(TokenKey, token)
}

export function removeToken() {
  return Storage.remove(TokenKey)
}
export function randomRange(min,max) {
  var returnStr = "",
  range = (max ? Math.round(Math.random() * (max-min)) + min : min),
  arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  for(var i=0; i<range; i++){
      var index = Math.round(Math.random() * (arr.length-1));
      returnStr += arr[index];
  }
  return returnStr;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js